<template>
  <div class="container">
    <div class="popup-wrap" id="popup">
      <div class="popup">
        <div class="popup-head">
            <p class="head-title">이벤트 상품 수령 안내</p>
            <p class="head-content">해당 이벤트 아이템을 수령하기 위해 <br> 주소 입력이 필요합니다.</p>
        </div>
        <div class="popup-body">	
          <div class="body-content">
            <div class="input_box">
              <label for="address_num">우편번호</label>
              <input type="number" id="address_num" v-model="zipCode">
            </div>
            <div class="input_box">
              <label for="address">주소</label>
              <input type="text" id="address" v-model="addr">
            </div>
            <div class="input_box">
              <label for="address_detail">상세주소</label>
              <input type="text" id="address_detail" v-model="addrDetail">
            </div>
          </div>
        </div>
        <div class="popup-foot">
          <div class="pop-btn close" @click="modalClose">
            <span>취소</span>
          </div>
          <div class="pop-btn confirm" @click="sendAddress">
             <span>입력완료</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import { insertAddress } from '@/api/event'
export default {
  props: {
      open: {
        type: Boolean
      }
  },
  methods: {
    modalOpen() {
       $("#popup").css('display','flex').hide().fadeIn();
    },
    modalClose() {
       $("#popup").fadeOut();
    },
    sendAddress() {
      if(this.requestAddress) return;
      this.requestAddress = true;

      insertAddress({
        nttId: this.$route.query.nttId,
        addr: this.addr,
        addrDetail: this.addrDetail,
        zipCode: this.zipCode
      })
      .then((res) => {
        console.log(res)
        this.requestAddress = false;
        if(res.data.resultCode == 1000){
          alert('주소가 입력되었습니다.')
          $("#popup").fadeOut();
        }else if(res.data.resultCode == 2200){
          alert('이미 주소가 입력되었습니다.')
          $("#popup").fadeOut();
        }
      })
    }
  },
  data() {
    return {
      addr: '',
      addrDetail: '',
      zipCode: '',
      requestAddress:false,
    }
  },
}
</script>

<style scoped>
.popup-wrap{
  background-color:rgba(0,0,0,.8); 
  justify-content:center; 
  align-items:center;     
  position:fixed;         
  top:0;
  left:0;
  right:0;
  bottom:0;               
  display: none; 
  padding:15px;
  z-index: 100;
}
.popup{
  width:100%;               
  max-width:400px;          
  border-radius: 20px;      
  overflow:hidden;          
  background-color:#fff;
  box-shadow: 5px 10px 10px 1px rgba(0,0,0,.3); 
}
.popup-head{
  width:100%;
  height:125px;  
  display:inline-block;
  text-align: center;
  padding-top: 30px;
  padding-bottom: 20px;
}

.popup-head .head-title {
  font-size: 18px;
  line-height: 35px;
}
.popup-head .head-content {
  font-size: 14px;
  line-height: 18px;
}
.popup-body{                
  width:100%;
  background-color:#ffffff; 
}
.body-content{              
  width:100%;
}
.body-content .input_box{              
  width:100%;
  border-top: 1px solid rgba(0,0,0,.2); 
  padding: 20px;
}
.body-content .input_box label{              
  display: inline-block;
  font-size: 12px;
  margin-bottom: 10px;
}
.body-content .input_box input{              
  display: inline-block;
  border: none;
  font-size: 16px;
  color: #000;
}
.popup-foot{                      
  /* //다리 */
  width:100%;
  height: 60px;
}
.pop-btn{ 
  display:inline-block;            
  width:50%;                     
  height:100%;                                    
  text-align: center;
  color:#fff;                 
  cursor:pointer;
  padding-top: 22px;
  font-size: 14px;                 
}

.pop-btn.close {
  background-color: #707070;
  border: 1px solid #707070; 
}
.pop-btn.confirm {
  background: var(--Gradient);
  border: 1px solid var(--Gradient); 
}
</style>